import FinancingPlansService, {
  type TPatientFinancingPlan,
} from "@/api/models/patient/financingPlan";
import { useGenericMutation } from "@/composables/shared/mutations/useGenericMutation";
import type { TVeeSetErrors } from "@/utils/DjangoError";

export function useCreateFinancingPlan(veeSetErrors?: TVeeSetErrors) {
  return useGenericMutation<TPatientFinancingPlan, Partial<TPatientFinancingPlan>>({
    mutationFn: (financingPlan) => FinancingPlansService.create({}, financingPlan),
    feature: "financingPlans-create",
    params: { veeSetErrors },
  });
}

export function useUpdateFinancingPlan(veeSetErrors?: TVeeSetErrors) {
  return useGenericMutation<TPatientFinancingPlan, Partial<TPatientFinancingPlan> & { id: string }>(
    {
      mutationFn: (financingPlan) =>
        FinancingPlansService.update({ id: financingPlan.id }, financingPlan),
      feature: "financingPlans-update",
      params: { veeSetErrors },
    }
  );
}
